export default __webpack_public_path__ + "static/media/minus.490b5243.svg";